import { render, staticRenderFns } from "./EmployeeBankDetails.vue?vue&type=template&id=68ae6a0b"
import script from "./EmployeeBankDetails.vue?vue&type=script&lang=js"
export * from "./EmployeeBankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports